<div class="{{className}}" *ngIf="dropDownButton.iconClassName">
    <itb-icon [matMenuTriggerFor]="dropdownList" [tooltipText]="dropDownButton.tooltipText" [className]="dropDownButton.iconClassName"></itb-icon>
    <mat-menu #dropdownList="matMenu">
        <button mat-menu-item *ngFor="let item of items" (click)="onItemClickHandler(item)">
            <a *ngIf="item.link" routerLink="{{item.link}}">
            <itb-icon [className]="item.iconClassName"></itb-icon>
            {{item.label}}</a>
            <div *ngIf="!item.link" class="dropup-items">
            <itb-icon [className]="item.iconClassName"></itb-icon>
            {{item.label}}
            </div>
        </button>
    </mat-menu>
</div>

<div class="{{className}}" *ngIf="dropDownButton.buttonClassName">
        <itb-round-button [matMenuTriggerFor]="dropdownList" [tooltipText]="dropDownButton.tooltipText" [className]="dropDownButton.buttonClassName" [iconClassName]="dropDownButton.buttonIconClassName"></itb-round-button>
        <mat-menu #dropdownList="matMenu">
            <button mat-menu-item *ngFor="let item of items" (click)="onItemClickHandler(item)">
                <a *ngIf="item.link" routerLink="{{item.link}}"><itb-icon [className]="item.iconClassName"></itb-icon>
                {{item.label}}</a>
                <div *ngIf="!item.link" class="dropup-items">
                <itb-icon [className]="item.iconClassName"></itb-icon>
                {{item.label}}
                </div>
            </button>
        </mat-menu>
    </div>